import React, { useState } from 'react';
import Header from './components/Header';
import Services from './components/Services';
import GoogleMap from './components/GoogleMap';
import Footer from './components/Footer';
import GalleryOverlay from './components/GalleryOverlay';
import './styles/style.css';

export default function App() {
    const [galleryOpen, setGalleryOpen] = useState(false);

    return (
        <>
            <Header onOpenGallery={() => setGalleryOpen(true)} />

            <main className="container">
                <Services />
                <GoogleMap />
            </main>

            <Footer />

            {galleryOpen && (
                <GalleryOverlay onClose={() => setGalleryOpen(false)} />
            )}
        </>
    );
}
